<template>
  <div class="Layout">
    <div class="wrapper">
      <div class="leftWrapper" :class="{ collapseStyle: $collapse }">
        <left-menu></left-menu>
      </div>
      <div class="rightWrapper" :class="{ pageWidth: $collapse }">
        <div class="headerContent">
          <header-nav></header-nav>
        </div>
        <!-- <TopLevelMenu /> -->
        <div class="layoutContent">
          <transition name="fade-transform" mode="out-in">
            <router-view :key="act" />
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderNav from "./components/HeaderNav";
import LeftMenu from "./components/LeftMenu";
// import TopLevelMenu from "./components/TopLevelMenu"
export default {
  name: "Layout",
  components: {
    LeftMenu,
    HeaderNav,
    // TopLevelMenu
  },
  data() {
    return {
      act: "",
    };
  },
  watch: {
    "$route.query": {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          // 兼容错误表单
          let type = val.type ? val.type : "noKey";
          this.act = val.id + type;
        }
      },
    },
  },
  methods: {},
};
</script>

<style lang="stylus" scoped>
.Layout
  background: $layoutBg
  .wrapper
    display: flex
    align-items: center
    overflow: hidden
  .leftWrapper
    z-index: 999
    width: 250px
    height: 100vh
    background: $leftBgColor
    overflow: auto
    transition: width 0.5s
  .collapseStyle
    width: 65px
  .pageWidth
    width: calc(100vw - 65px) !important
  .rightWrapper
    height: 100vh
    width: calc(100vw - 200px)
    transition: width 0.5s
    overflow: hidden
    .headerContent
      display: flex
      align-items: center
      background: $headBgColor
      height: 50px
      box-shadow: 0px 4px 16px 0px rgba(66, 89, 91, 0.3)
    .layoutContent
      margin-top: 20px
      margin-left: 40px
      margin-right:40px
      padding: 0 0px 20px
      height: calc(100vh - 70px)
      width : calc(100% - 80px)
</style>
